import type { ReactNode } from 'react'
import React from 'react'
import type { AlertVariants } from '@vtex/admin-ui'
import { Alert, csx } from '@vtex/admin-ui'

type ProductSkuAlertProps = {
  type: AlertVariants
  children: ReactNode
}

export const ProductSkuAlert = ({ type, children }: ProductSkuAlertProps) => {
  return (
    <Alert
      variant={type}
      className={csx({ height: '3.375rem', marginBottom: '$space-5' })}
    >
      {children}
    </Alert>
  )
}
